import { FieldErrorWrapper, IconButton } from 'components/Blocks';
import { EyeIcon, EyeOffIcon } from 'components/Blocks/Icons';
import { getFormConfig, useFormContext } from 'components/Form';
import { useToggleV2 } from 'hooks';
import { useLang } from 'locale';
import { translateError } from 'utils/validation';

interface PasswordInputProps {
  name: 'password' | 'confirmPassword';
  form: Pick<ReturnType<typeof getFormConfig>, 'Input'>;
}

export function PasswordInput({ name, form }: PasswordInputProps) {
  const { t } = useLang();

  const [shown, { toggle }] = useToggleV2();

  const { formState } = useFormContext<Record<PasswordInputProps['name'], string>>();

  return (
    <FieldErrorWrapper
      error={name === 'confirmPassword' && translateError(formState.errors.confirmPassword, t)}
    >
      <div className="relative">
        <form.Input
          property={name}
          type={shown ? 'text' : 'password'}
          className="pr-10"
          label={t(name === 'password' ? 'password' : 'confirm-password')}
          fullWidth
          handleError={false}
        />

        <IconButton
          size="small"
          className="absolute bottom-1.5 right-2 text-muted-foreground"
          onClick={toggle}
        >
          {shown ? <EyeOffIcon size={14} /> : <EyeIcon size={14} />}
        </IconButton>
      </div>
    </FieldErrorWrapper>
  );
}
